/* eslint-disable @typescript-eslint/no-use-before-define */
import {
    Action,
    ActionReducerMap,
    createFeatureSelector,
    createSelector,
    StoreModule,
} from '@ngrx/store';
import { RideArea } from '@polaris-customerweb/sharedcomponents.map';
import {
    RideAreaAction,
    SetActiveRideArea,
    SetRideAreas,
    UpdateRideArea,
} from './ride-area.actions';

const featureName = 'rideArea';

export interface RideAreaState {
    activeRideArea?: RideArea;
    rideAreas: RideArea[];
}

const reducerMap: ActionReducerMap<RideAreaState> = {
    activeRideArea: activeRideAreaReducer,
    rideAreas: rideAreasReducer,
};

export const selectRideAreaState =
    createFeatureSelector<RideAreaState>(featureName);
export const selectActiveRideArea = createSelector(
    selectRideAreaState,
    (state) => state.activeRideArea
);
export const selectRideAreas = createSelector(
    selectRideAreaState,
    (state) => state.rideAreas
);

export const rideAreaStoreModule = StoreModule.forFeature(
    featureName,
    reducerMap
);

function activeRideAreaReducer(state: RideArea, action: Action) {
    switch (action.type) {
        case RideAreaAction.setActiveRideArea:
            return (action as SetActiveRideArea).rideArea;
        default:
            return state;
    }
}

function rideAreasReducer(state: RideArea[] = [], action: Action) {
    switch (action.type) {
        case RideAreaAction.setRideAreas:
            return (action as SetRideAreas).rideAreas;
        case RideAreaAction.updateRideArea:
            return [
                ...state.filter(
                    (rideArea) =>
                        rideArea.id !== (action as UpdateRideArea).rideArea.id
                ),
                (action as UpdateRideArea).rideArea,
            ];
        default:
            return state;
    }
}
